import { createReducer, isAnyOf } from '@reduxjs/toolkit'
import { castDraft } from 'immer'

import { CONTENT_LIBRARY } from '@constants'
import { AuthActionTypes } from '@store/auth'
import { IBrandsState } from '@store/brands'
import {
  addBrand,
  addBrandError,
  addBrandSuccess,
  fetchBrands,
  fetchBrandsError,
  fetchBrandsSuccess,
  updateBrand,
  updateBrandError,
  updateBrandSuccess,
} from './actions'

const initialState: IBrandsState = {
  isFetching: false,
  isFetchingContentLibrary: false,
  isAdding: false,
  isUpdating: false,
  hasFetched: false,
  errors: undefined,
  brandsById: {},
  contentLibraryBrandsById: {},
  links: [],
}

const reducer = createReducer(initialState, (builder) => {
  builder
    .addCase(fetchBrands, (state, { payload }) => {
      if (payload?.context === CONTENT_LIBRARY) {
        state.isFetchingContentLibrary = true
      } else {
        state.isFetching = true
      }
    })
    .addCase(addBrand, (state) => {
      state.isAdding = true
    })
    .addCase(updateBrand, (state) => {
      state.isUpdating = true
    })
    .addCase(fetchBrandsSuccess, (state, { payload }) => {
      const { items, links, context } = payload
      if (context === CONTENT_LIBRARY) {
        state.isFetchingContentLibrary = false
        state.contentLibraryBrandsById = {}
        items.forEach((item) => (state.contentLibraryBrandsById[item.id] = item))
      } else {
        state.isFetching = false
        state.hasFetched = true
        state.links = links
        items.forEach((item) => (state.brandsById[item.id] = item))
      }
    })
    .addCase(fetchBrandsError, (state, { payload }) => {
      state.isFetching = false
      state.isFetchingContentLibrary = false
      state.errors = payload
    })
    .addCase(addBrandError, (state) => {
      state.isAdding = false
    })
    .addMatcher(isAnyOf(addBrandSuccess, updateBrandSuccess), (state, { payload }) => {
      state.isAdding = false
      state.isUpdating = false
      state.brandsById[payload.id] = castDraft(payload)
    })
    .addMatcher(isAnyOf(updateBrandError, addBrandError), (state, { payload }) => {
      state.isFetching = false
      state.errors = payload
    })
    .addMatcher(isAnyOf(addBrand, fetchBrands, updateBrand), (state) => {
      state.errors = undefined
    })
    .addMatcher(
      (action) => action.type === AuthActionTypes.SIGNOUT_SUCCESS,
      () => initialState,
    )
})

export { reducer as brandsReducer }
